<template>
    <div class="consultation__conten">
        <NavSecond :banner="icon_stra" :noNeedCate="true"></NavSecond>
        <div class="cate__ul animate__animated animate__fadeIn">
<!--            <router-link v-for="(item, index) in cateList" :key="index" tag="div" active-class="active" :to="item.path" >{{item.name}}</router-link>-->
            <div v-for="(item, index) in cateList" :class="item.active ? 'active' : ''" :key="index" @click="cateFun(item)">{{item.name}}</div>
        </div>
        <div v-if="articleList.length > 0">
            <div class="wrapper__wpd relative" style="background: #f1f1f1;">
                <div class="time__ul">
                    <div class="time__item  animate__fadeInUp case_hover_box" @click="preeItem('/consultation/consdetail', {id: itn.id})" :class="index >2 ? 'wow' : 'animate__animated'" data-wow-delay=".2s" data-wow-duration="0.8s" v-for="(itn,index) in articleList" :key="index" >
                        <div class="time__face hv hover_box_img"><img :src="itn.cover"> </div>
                        <div class="time__des">
                            <div class="ti">{{itn.time}}</div>
                            <div class="tit textover">{{itn.name}}</div>
                        </div>
                    </div>
                </div>
                <div class="bank" style=""></div>
            </div>
            <div class="footer">
                <div class="wrapper__wpd page">
                    <el-pagination
                            @size-change="handleSizeChange"
                            background
                            :current-page="pagenum"
                            :page-size="pagesize"
                            :total="count"
                            layout="prev, pager, next"
                            >
                    </el-pagination>
                </div>
                <Footer></Footer>
            </div>
        </div>
        <div v-else>
            <EmptyPage style="margin-top: -150px"></EmptyPage>
        </div>
    </div>
</template>

<script>
    import icon_stra from '@/assets/img/cos01.png'
    import NavSecond from '@/components/NavSecond'
    import Footer from '@/layouts/Footer'
    import EmptyPage from '@/components/EmptyPage'



    export default {
        name: 'Test',
        data (){
            return {
                icon_stra,
                // cateList: [
                //     {
                //         name: '全部',
                //         path: '/consultation/0',
                //     },
                //     {
                //         name: '项目讲解',
                //         path: '/consultation/100',
                //     },
                //     {
                //         name: '团队建设',
                //         path: '/consultation/200',
                //     },
                //     {
                //         name: '工艺标准',
                //         path: '/consultation/300',
                //     },
                //     {
                //         name: '交流研学',
                //         path: '/consultation/400',
                //     },
                //     {
                //         name: '装修百科',
                //         path: '/consultation/500',
                //     },
                //     {
                //         name: '业主心声',
                //         path: '/consultation/600',
                //     },
                // ]
                cateList: [],
                articleList: [],
                count: 0,
                pagesize: 9,
                pagenum: 1,
            }
        },
        watch: {
            '$route' (to, form) {
                this.pagesize = 9
                this.init()
            }
        },
        components: {
            NavSecond, Footer, EmptyPage
        },
        methods:{
            /**
             * @description点击跳转
             * */
            preeItem (path, query){
                this.$router.push({path, query})
            },
            handleSizeChange (val) {
                // this.$emit('nodeConfigHandler', {
                //     param: {
                //         pagenum: 1,
                //         pagesize: val
                //     },
                //     component: 'pageChange'})
            },
            /**
             * @description获取分类对应列表数据
             * */
            getArticleList (){
                this.$xhr(this.$api.articleList, {pagesize: this.pagesize, pagenum: this.pagenum, category_id: this.category_id}).then(res => {
                    this.count = res.count
                    this.articleList = res.list
                })
            },
            /**
             * @description获取分类
             * */
            getCateList (){
                this.$xhr(this.$api.articleCategory, {}).then(res => {
                    res.unshift({name: '全部', id:  '0', active: true})
                    this.cateList = res
                    this.cateList.map((v, k)=>{
                        if (this.$route.query.type){
                            v.active = false
                            if (v.id == this.$route.query.type){
                                v.active = true
                            }
                        }
                        return v
                    })
                })
            },
            cateFun (item){
                this.pagesize = 9
                this.pagenum = 1
                this.cateList = this.cateList.map((v, k)=>{
                    v.active = false
                    if (v.id == item.id){
                        v.active = true
                        this.category_id = item.id
                        this.getArticleList()
                    }
                    return v
                })
            },
            init (){
                if (this.$route.query.type) {
                    this.category_id = this.$route.query.type
                } else {
                    this.category_id = 0
                }
                // if (localStorage.case){
                    let res =  this.cateList
                    // res.unshift({name: '全部', id:  '0', active: true})
                    this.cateList = res.map(v=>{
                        if (this.$route.query.type){
                            v.active = false
                            if (v.id == this.$route.query.type){
                                v.active = true
                            }
                        }
                        return v
                    })
                // }
                this.getArticleList()
            }
        },
        mounted() {
            this.$wow.init()
            this.getCateList()
            this.init()
        },
    }
</script>
<style  lang="scss" scoped>
    .consultation__conten{
        .cate__ul{
            text-align: center;
            margin-top: 110px;
            padding-bottom: 300px;
            & > div{
                display: inline-block;
                font-size: 16px;
                font-weight: 400;
                color: #010101;
                position: relative;
                padding: 0 30px;
                cursor: pointer;
                &::before{
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 1px;
                    width: 2px;
                    height: 16px;
                    background: #000000;
                }
                &:nth-child(1)::before{
                    content: '';
                    display: none;
                }
            }
            .active{
                color: #F55E1C;
            }
        }
        .time__ul {
            overflow: hidden;
            position: relative;
            top: -250px;
            .time__item {
                cursor: pointer;
                width: 31.33%;
                float: left;
                margin-right: 3%;
                margin-bottom: 3%;
                img{
                    width: 100%;
                    display: block;
                    height: 280px;
                }
                .time__des{
                    background: #fff;
                    padding-top: 7px;
                    .ti{
                        font-size: 12px;
                        font-weight: 400;
                        color: #808080;
                        position: relative;
                        display: inline;
                        padding-left: 15px;
                        padding-bottom: 2px;
                        &::before{
                            content: '';
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            height: 2px;
                            width: 100%;
                            background: #F55E1B;
                        }
                    }
                    .tit{
                        padding: 10px 15px;
                        font-size: 16px;
                        font-weight: 400;
                        color: #000000;
                        padding-bottom: 20px;
                    }
                }
            }
            .time__item:nth-child(3n){
                margin-right: 0;
            }
        }
        .bank{
            height: 250px;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            background: #fff;
        }
        .footer{
            position: relative;
            margin-top: -250px;
            .page{
                text-align: right;
                padding-top: 30px;
                padding-bottom: 40px;
            }
        }

    }

</style>
